// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Fabelwesen „Wichtel": lugt von unten ins Bild, tippt zum Gruß an die Zipfelmütze.
export default function Wichtel() {
  return (
    <svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg">
      {/* Der Guck-Effekt: die Gruppe startet unter der viewBox-Kante (CSS translateY) */}
      <g
        className="wichtel"
        fill="none"
        stroke="var(--tanne)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* Zipfelmütze (tippt) */}
        <g className="wichtel-hut">
          <path d="M34 58 C36 36 46 18 64 10 C66 30 80 36 86 52 C72 62 48 62 34 58 Z" fill="var(--moos)" />
          {/* Bommel */}
          <circle cx="64" cy="10" r="3.5" fill="var(--sand)" />
          {/* Mützenrand */}
          <path d="M34 58 C50 64 72 62 86 52" strokeWidth="3" />
        </g>
        {/* Augen */}
        <circle cx="51" cy="66" r="2.2" fill="var(--tanne)" stroke="none" />
        <circle cx="69" cy="66" r="2.2" fill="var(--tanne)" stroke="none" />
        {/* Knollennase */}
        <circle cx="60" cy="72" r="6" fill="var(--sand)" />
        {/* Bart */}
        <path d="M40 66 C34 92 46 110 60 116 C74 110 86 92 80 66 C72 78 48 78 40 66 Z" fill="var(--creme)" />
        {/* Bartlinien */}
        <path d="M52 88 C54 96 58 102 60 104 M68 88 C66 96 62 102 60 104" stroke="var(--sand)" />
      </g>
    </svg>
  )
}
